'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ExtendedButton = require('./ExtendedButton');

var _ExtendedButton2 = _interopRequireDefault(_ExtendedButton);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StepperTable = function () {
  function StepperTable() {
    _classCallCheck(this, StepperTable);
  }

  _createClass(StepperTable, null, [{
    key: 'buildStepperTable',
    value: function buildStepperTable(number, countSteps, title, content, buttonContinue, buttonBack, buttonOrder, orderText, orderFuntion) {
      var btoContinue = '';
      if (buttonContinue === true) {

        if (orderFuntion !== null && orderFuntion !== undefined && typeof orderFuntion === 'function') {
          btoContinue = _react2.default.createElement(_ExtendedButton2.default, {
            Id: "buttonContinue",
            Usable: true,
            Text: _Vas2.default.getText('Labels', "Continue"),
            Float: "left",
            Width: 180,
            OnClick: function OnClick() {
              _utilsLib.Jump.jump(countSteps, number + 1, number.toString());orderFuntion();
            } });
        } else {
          btoContinue = _react2.default.createElement(_ExtendedButton2.default, {
            Id: "buttonContinue",
            Usable: true,
            Text: _Vas2.default.getText('Labels', "Continue"),
            Float: "left",
            Width: 180,
            OnClick: function OnClick() {
              _utilsLib.Jump.jump(countSteps, number + 1, number.toString());
            } });
        }
      }

      var btoBack = '';
      if (buttonBack === true) {
        btoBack = _react2.default.createElement(_ExtendedButton2.default, {
          Id: "buttonBack",
          Usable: true,
          Text: _Vas2.default.getText('Labels', "Back"),
          Width: 180,
          Float: "left",
          OnClick: function OnClick() {
            _utilsLib.Jump.jump(countSteps, number - 1, number.toString());
          } });
      }

      var btoOrder = '';
      if (buttonOrder === true && orderFuntion !== null && orderFuntion !== undefined && typeof orderFuntion === 'function') {
        btoOrder = _react2.default.createElement(_ExtendedButton2.default, {
          Usable: true,
          Text: orderText ? _Vas2.default.getText('Labels', orderText) == undefined ? "Text fehlt in component-lib/de.json" : _Vas2.default.getText('Labels', orderText) : _Vas2.default.getText('Labels', "OrderCosts"),
          OnClick: function OnClick() {
            orderFuntion();
          },
          Float: "left",
          Width: 180,
          Id: "btoOrder" });
      }
      return _react2.default.createElement(
        'table',
        {
          id: "StepperTable_" + title,
          className: "StepperTable" },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            { onClick: function onClick() {
                _utilsLib.Jump.jump(countSteps, number.toString());
              } },
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'div',
                {
                  id: "i" + number.toString(),
                  className: "StepperIcon" },
                number
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'div',
                { className: "StepperLabel" },
                title
              )
            )
          ),
          _react2.default.createElement(
            'tr',
            {
              id: number.toString(),
              className: "c",
              style: { display: 'none' } },
            _react2.default.createElement('td', { className: "StepperConnector" }),
            _react2.default.createElement(
              'td',
              null,
              content,
              _react2.default.createElement('br', null),
              btoBack,
              btoContinue,
              btoOrder
            )
          )
        )
      );
    }
  }, {
    key: 'buildStepperTableNotVisible',
    value: function buildStepperTableNotVisible(name, title, content) {
      return _react2.default.createElement(
        'table',
        {
          id: "StepperTable_" + name,
          className: "StepperTable",
          style: { display: 'none' } },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement('td', null),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'div',
                { className: "StepperLabel" },
                title
              )
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement('td', { className: "StepperConnector" }),
            _react2.default.createElement(
              'td',
              null,
              content
            )
          )
        )
      );
    }
  }]);

  return StepperTable;
}();

exports.default = StepperTable;